module.exports = __webpack_public_path__ + "media/images/emblems/Chatillon-12e474098fc0f1350594e4c288aa1152.png";